module.exports = __webpack_public_path__ + "static/img/role.0f8189e.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/swbnzk/role.png
// module id = B8k9
// module chunks = 7